{
  "title": "คลังข้อมูลการ์ด",
  "intro": "รายการการ์ดที่ร้านขายได้ — เกม ชุด และการ์ด ไม่ใช่สต็อก: สินค้าที่ขายจะสร้างจากการ์ดในนี้",
  "breadcrumb": "ตำแหน่งในคลังข้อมูลการ์ด",
  "games": {
    "title": "เกม",
    "add": "เพิ่มเกม",
    "save": "บันทึกเกม",
    "created": "เพิ่มเกม \"{{name}}\" แล้ว",
    "empty": "ยังไม่มีเกม",
    "empty_hint": "เพิ่มเกมแรก (เช่น Pokémon)",
    "hidden": "ซ่อนอยู่",
    "save_order": "บันทึกลำดับนี้",
    "undo_order": "คืนลำดับเดิม",
    "order_saved": "บันทึกลำดับแล้ว",
    "price_check": "ตรวจราคา",
    "price_check_title": "ตรวจราคาของ {{name}}",
    "price_check_intro": "การ์ดของเกมนี้ ไม่ได้ตรวจราคากี่วันจึงขึ้นสีเหลือง (ใกล้ถึงเวลาตรวจ) หรือสีแดง (เลยเวลาตรวจ) — เว้นว่างไว้ = ใช้ค่าของร้าน",
    "warn_days": "เหลืองเมื่อเกิน … วัน",
    "alert_days": "แดงเมื่อเกิน … วัน",
    "shop_default": "ค่าของร้าน: {{days}}",
    "days_suffix": "วัน",
    "price_check_rule": "เหลืองเกิน {{warn}} วัน · แดงเกิน {{alert}} วัน",
    "price_check_custom": "ตั้งเอง: เหลืองเกิน {{warn}} · แดงเกิน {{alert}} วัน",
    "price_check_saved": "บันทึกจำนวนวันตรวจราคาแล้ว",
    "days_range": "ใส่เลขจำนวนเต็ม 1–365",
    "days_order": "สีเหลืองต้องมาก่อนสีแดง: จำนวนวันเหลืองต้องน้อยกว่าแดง ({{warn}} / {{alert}})"
  },
  "sets": {
    "title": "ชุด",
    "intro": "ชุดการ์ดของเกมนี้ เปิดชุดเพื่อดูและเพิ่มการ์ด",
    "add": "เพิ่มชุด",
    "edit": "แก้ชุด",
    "edit_named": "แก้ {{name}}",
    "save": "บันทึกชุด",
    "created": "เพิ่มชุด \"{{name}}\" แล้ว",
    "saved": "บันทึกชุดแล้ว",
    "empty": "ยังไม่มีชุด",
    "empty_hint": "เพิ่มชุดด้วยรหัสชุด เช่น SV2a",
    "duplicate": "เกมนี้มีชุดรหัสนี้ภาษาเดียวกันอยู่แล้ว",
    "delete": "ลบชุด",
    "delete_named": "ลบ {{name}}",
    "delete_title": "ลบชุดนี้?",
    "delete_consequence": "\"{{name}}\" จะถูกลบออกจากคลังข้อมูลการ์ด สินค้าที่ขายอยู่ไม่เปลี่ยน",
    "deleted": "ลบชุดแล้ว",
    "in_use": "ชุดนี้ยังมีการ์ดหรือสินค้าอยู่ — ลบไม่ได้"
  },
  "cards": {
    "title": "การ์ด",
    "intro": "การ์ดในชุดนี้ แสดงชื่อญี่ปุ่นคู่กับชื่ออังกฤษ",
    "add": "เพิ่มการ์ด",
    "edit": "แก้การ์ด",
    "edit_named": "แก้ {{name}}",
    "save": "บันทึกการ์ด",
    "created": "เพิ่มการ์ด \"{{name}}\" แล้ว",
    "saved": "บันทึกการ์ดแล้ว",
    "empty": "ชุดนี้ยังไม่มีการ์ด",
    "empty_hint": "เพิ่มการ์ดใบแรกด้วยเลขและชื่อ",
    "in_stock": "ร้านมีสต็อก",
    "stock_n": "มี {{count}} ใบ",
    "stock_none": "ไม่มี",
    "delete": "ลบการ์ด",
    "delete_named": "ลบ {{name}}",
    "delete_title": "ลบการ์ดนี้?",
    "delete_consequence": "\"{{name}}\" จะถูกลบออกจากคลังข้อมูลการ์ด",
    "deleted": "ลบการ์ดแล้ว",
    "in_use": "มีสินค้าที่สร้างจากการ์ดนี้ — ลบไม่ได้",
    "import": "นำเข้าการ์ดของชุดนี้ ({{source}})",
    "imported": "นำเข้า {{count}} ใบแล้ว",
    "import_off": "ยังไม่เปิดใช้การนำเข้าจากแหล่งนี้"
  },
  "fields": {
    "game": "เกม",
    "set": "ชุด",
    "set_code": "รหัสชุด",
    "set_code_hint": "ตามที่พิมพ์บนการ์ด เช่น SV2a",
    "set_name": "ชื่อชุด",
    "language": "ภาษาการ์ด",
    "language_hint": "ภาษาที่พิมพ์บนการ์ด",
    "name_en": "ชื่อ (อังกฤษ)",
    "name_jp": "ชื่อ (ญี่ปุ่น)",
    "name_ja": "ชื่อ (ญี่ปุ่น)",
    "name_th": "ชื่อ (ไทย)",
    "number": "เลขการ์ด",
    "number_hint": "ตามที่พิมพ์ เช่น 085/165",
    "rarity": "ความหายาก",
    "card_type": "ประเภทการ์ด",
    "character": "ตัวละคร",
    "card_name": "ชื่อ",
    "reference_image": "รูป (ที่อยู่เว็บ)",
    "reference_image_hint": "รูปการ์ดบนอินเทอร์เน็ต (https://…) — แสดงตอนเลือกการ์ด",
    "reference_image_bad": "ใช้ที่อยู่เว็บที่ขึ้นต้นด้วย https://",
    "release_date": "วันวางขาย",
    "total_cards": "จำนวนการ์ดในชุด",
    "total_cards_bad": "ใส่เป็นจำนวนเต็ม",
    "logo": "โลโก้ชุด",
    "publisher": "ผู้ผลิต"
  },
  "languages": {
    "JP": "ญี่ปุ่น",
    "EN": "อังกฤษ",
    "TH": "ไทย",
    "KR": "เกาหลี",
    "ZH": "จีน"
  },
  "picker": {
    "label": "การ์ดใบไหน?",
    "hint": "พิมพ์ชื่อญี่ปุ่นหรืออังกฤษ เลขการ์ด หรือรหัสชุด + เลข (เช่น SV2a 085) หรือสแกนเลขการ์ดเกรดก็ได้",
    "placeholder": "เช่น ブラッキー / Umbreon / 085",
    "set_filter": "เฉพาะชุดนี้",
    "all_sets": "ทุกชุด",
    "results": "การ์ดที่ตรง",
    "searching": "กำลังค้น…",
    "clear": "ล้าง",
    "none": "ไม่พบการ์ดที่ตรงกับ \"{{text}}\"",
    "error": "ค้นรายการการ์ดไม่ได้ ลองอีกครั้ง",
    "number": "เลข {{number}}",
    "set_loading": "…",
    "change": "เลือกการ์ดใบอื่น",
    "create": "ไม่มีในรายการ? เพิ่มการ์ดใหม่",
    "use_as_cert": "{{cert}} เป็นเลขการ์ดเกรด — ใช้เลขนี้"
  },
  "create": {
    "title": "เพิ่มการ์ดใหม่ในคลังข้อมูลการ์ด",
    "hint": "กรอก 4 ช่องก็พอ รายละเอียดอื่นเพิ่มทีหลังได้ในคลังข้อมูลการ์ด",
    "save": "เพิ่มการ์ดนี้",
    "cancel": "ยกเลิก",
    "required": "กรุณากรอกช่องนี้",
    "duplicate": "ชุดนี้มีการ์ดใบนี้อยู่แล้ว",
    "twin": "ชุดนี้มีการ์ดเลข {{number}} อยู่แล้ว:",
    "use_existing": "ใช้การ์ดใบนี้"
  }
}
